import { DetailsListView, EntityGridListProps } from '../../Common/DetailsList/DetailListView';
import { Icon } from '@fluentui/react';
import { DocumentContentTypeIcon } from '../../Proyectos/DocumentContentTypeIcon';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { styled } from '@fluentui/react';
import { parseDateTimeForList } from '../../../lib/Util';

export const DocumentGridList = (props: EntityGridListProps) => {
  const { t, i18n } = useTranslation();

  const formatActivo = (item: any) => {
    if (item.doc_activo) {
      return <Icon iconName="CheckMark" className="color-success" />;
    } else {
      return <Icon iconName="Cancel" className="color-error" />;
    }
  };

  const formatDateMM_YYYY = (date: string | null) => {
    if (date) {
      return <span>{DateTime.fromISO(date).toFormat("dd/MM/yyyy")}</span>;
    }
  };

  const formatDateOnlyMonthYear = (date: string | null) => {
    if (date) {
      const dateFormat = DateTime.fromFormat(date, "dd/MM/yyyy");
      return <span style={{ paddingLeft: "25px" }}>{dateFormat.toFormat("MM/yyyy")}</span>;
    }
  };

  const formatArchivo = (item: any) => {
    return (
        <span>
        <DocumentContentTypeIcon name={item.doc_nombre} /> &nbsp;{item.doc_nombre}
      </span>
    );
  };

  const columns = [
    { fieldName: 'doc_nombre', name: t('Nombre'), _onRender: (item: any) => formatArchivo(item) },
    { fieldName: 'doct_nombre', name: t('Tipo') },
    { fieldName: 'doci_fecha_carga', name: t('Fecha de carga') , _onRender: (item: any) => parseDateTimeForList(props.system, item.doci_fecha_carga) },
    { fieldName: 'col_nombre', name: t('Cargado por') },
    { fieldName: 'pro_codigo', name: t('Proyecto codigo') },
    { fieldName: 'pro_nombre', name: t('Proyecto nombre') },
    { fieldName: 'act_fecha', name: t('Fecha actividad'), _onRender: (item: any) => formatDateMM_YYYY(item.act_fecha) },
    { fieldName: 'doc_refiere_a_periodo', name: t('Refiere a periodo'), styled: {width: "120px"}, _onRender: (item: any) => formatDateOnlyMonthYear(item.doc_refiere_a_periodo)},
    { fieldName: 'act_nombre', name: t('Actividad') },
    { fieldName: 'doc_activo', name: t('Activo'), _onRender: (item: any) => formatActivo(item) },
  ];

  return (
      <>
        <DetailsListView
            changeBlockUI={props.changeBlockUI}
            keyList={props.keyList}
            onClickCardMode={() => props.onClickCardMode()}
            onClickGridMode={() => props.onClickGridMode()}
            mode={props.mode}
            title={t('Documentos')}
            cols={columns}
            isGridList={true}
            listFilters={[]}
            quickFilters={props.quickFilters}
            onItemClick={props.onItemClick}
            baseUrl={props.baseUrl}
            courier={props.courier}
            refresh= {props.refresh}
        ></DetailsListView>
      </>
  );
};
